/**
 * Story card plain text controller
 * @author Denis Sobolev, Ryan Gladstone
 */

function PlainTextController($scope) {
  $scope.timeFilter = $scope.filterSet.getFilter('startDate');

  $scope.channelPath = $scope.filterSet && $scope.filterSet.getFilterValue('plan') ? $scope.filterSet.getFilterValue('plan') : null;

  $scope.status = { selected: false };

  $scope.getStartTime = () => $scope.timeFilter.value;
}


const ctrlArr = [
  '$scope',
  PlainTextController
];

export default function (ngModule) {
  ngModule.controller('PlainTextController', ctrlArr);
}
